<template>
    <ul
        ref="slider"
        class="text_slider"
        :class="[{ animate: isAnimate }, { revers: isReverse }, { vertical: isVertical }]"
        :style="{ animationDuration: duration + 's' }"
        v-if="$props.list && $props.list.length > 0"
    >
        <!-- 원본 -->
        <li v-for="(content, idx) in list" :key="`origin_${idx}`">
            <p>{{ content }}</p>
        </li>

        <!-- 복제 -->
        <li v-if="isAnimate" v-for="(content, idx) in list" :key="`clone_${idx}`">
            <p>{{ content }}</p>
        </li>
    </ul>
</template>

<script lang="ts">
    import { ref, onMounted, watch } from "@/BaseComponent";
    import { nextTick } from "vue";

    export default {
        props: {
            list: Array<String>,
            isVertical: Boolean,
            isReverse: Boolean,
        },
        setup(props: any) {
            const slider = ref<HTMLElement | null>(null);
            const isAnimate = ref(false);
            const duration = ref(25);

            const checkOverflow = () => {
                nextTick(() => {
                    if (!slider.value) return;

                    const parent = slider.value.parentElement;
                    if (!parent) return;

                    const contentSize = props.isVertical ? slider.value.scrollHeight : slider.value.scrollWidth;

                    const parentSize = props.isVertical ? parent.clientHeight : parent.clientWidth;

                    const isOver = contentSize > parentSize;

                    isAnimate.value = isOver;

                    if (isOver) {
                        const ratio = contentSize / parentSize;
                        if (!props.isVertical) duration.value = 13 * ratio;
                        else duration.value = 7 * ratio;
                    }
                });
            };

            onMounted(() => {
                checkOverflow();
                window.addEventListener("resize", checkOverflow);
            });

            watch(() => props.list, checkOverflow, { deep: true });

            return { isAnimate, slider, duration };
        },
    };
</script>

<style scoped>
    .text_slider {
        display: flex;
        flex-direction: row;
        will-change: transform;

        animation: none;
    }

    .text_slider.animate {
        animation: marquee linear infinite;
    }

    .text_slider.vertical {
        flex-direction: column;
    }

    .text_slider.vertical.animate {
        animation: marquee_vertical linear infinite;
    }

    .text_slider.revers.animate {
        animation: marquee_revers linear infinite;
    }

    @keyframes marquee {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-50%);
        }
    }

    @keyframes marquee_vertical {
        0% {
            transform: translateY(32%);
        }
        100% {
            transform: translateY(-19%);
        }
    }

    @keyframes marquee_revers {
        0% {
            transform: translateX(-50%);
        }
        100% {
            transform: translateX(0);
        }
    }

    .text_slider li {
        margin: 0;
        padding: 0;
        list-style: none;
    }
</style>
